import React from "react";
import { Stack, Box } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import { DashboardHeader } from "../shared";
import UserStatsPanel from "./UserStatsPanel";
import SystemHealthPanel from "./SystemHealthPanel";
import AuditLogPanel from "./AuditLogPanel";

import useAdminDashboard from "../../hooks/useAdminDashboard";

/**
 * Admin Dashboard
 * Vista de administración del sistema con usuarios, salud y auditoría
 */
export default function AdminDashboard() {
  const {
    loading,
    userStats,
    systemHealth,
    auditLog,
    securityAlerts,
    onGoUserManagement,
    onGoAuditLog,
  } = useAdminDashboard();

  return (
    <Stack spacing={3}>
      <DashboardHeader
        title="System Administration"
        subtitle="User management, system health monitoring, and audit logs"
        icon={<AdminPanelSettingsIcon />}
        color="secondary"
      />

      {/* User Stats */}
      <UserStatsPanel
        loading={loading}
        stats={userStats}
        onGoUserManagement={onGoUserManagement}
      />

      {/* System Health + Audit Log side by side */}
      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
          alignItems: "start",
        }}
      >
        <SystemHealthPanel
          loading={loading}
          health={systemHealth}
          alerts={securityAlerts}
        />

        <AuditLogPanel
          loading={loading}
          auditLog={auditLog}
          onGoAuditLog={onGoAuditLog}
        />
      </Box>
    </Stack>
  );
}
